import { Alert, Box } from 'app/components/design-system-components'
import * as dateTimeHelpers from 'app/utils/datetime/helpers'

interface PublishingOptionsAlertProps {
  isCreating?: boolean
  hasConfirmation?: boolean
  confirmedBy?: string
  confirmedAt?: Date | string
  isImplicitFeedConfirmation?: boolean
  listedAt?: Date | string
  listedBy?: string
  isPublishedOption?: boolean
}

const PublishingOptionsAlert: React.FC<PublishingOptionsAlertProps> = ({
  isCreating = true,
  hasConfirmation = false,
  confirmedBy,
  confirmedAt,
  isImplicitFeedConfirmation = false,
  listedAt,
  listedBy,
  isPublishedOption,
}) => {
  if (!isCreating && !hasConfirmation) {
    return (
      <Alert variant="warningWithBg" showLeftIcon leftIconVariant="warning">
        This Victorian property was listed / marked Live at{' '}
        {dateTimeHelpers.formatTime(
          listedAt,
          dateTimeHelpers.SHORT_STANDARD_DATETIME,
        )}{' '}
        by {listedBy || 'property uploader'} without confirmation that it meets
        Consumer Affairs Victoria Minimum Standards.{' '}
        {isPublishedOption &&
          'Save as Off Market and then save as Live to record confirmation.'}
      </Alert>
    )
  }

  const confirmationText = (
    <>
      <strong className="text-blue-600">
        {isImplicitFeedConfirmation
          ? 'Implicit confirmation received via Property Feed'
          : `${confirmedBy} confirmed`}
      </strong>{' '}
      {dateTimeHelpers.formatTime(
        confirmedAt,
        dateTimeHelpers.SHORT_STANDARD_DATETIME,
      )}
      .
    </>
  )

  return (
    <Alert variant="blueWithBg" showLeftIcon leftIconVariant="info">
      <Box>
        Properties advertised in Victoria must meet minimum standards before
        listing. <>{hasConfirmation && confirmationText}</>
      </Box>
    </Alert>
  )
}

export default PublishingOptionsAlert
